import { render, staticRenderFns } from "./changePasswordPage.vue?vue&type=template&id=4a6ed6a2&scoped=true"
import script from "./changePasswordPage.vue?vue&type=script&lang=js"
export * from "./changePasswordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6ed6a2",
  null
  
)

export default component.exports